/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {StateConfigurationModel} from '../../../shared/status-timeline/models/state-configuration.model';

const timelineHappyPath: {
    happyPathPending: StateConfigurationModel;
    happyPathAnalysis: StateConfigurationModel;
    happyPathSolved: StateConfigurationModel;

} = {
    happyPathPending: {
        code: 'PENDING',
        name: 'Pending',
        color: '#444444'
    },
    happyPathAnalysis: {
        code: 'ANALYSIS',
        name: 'Analysis',
        color: '#444444'
    },
    happyPathSolved: {
        code: 'SOLVED',
        name: 'Solved',
        color: '#444444',
        finalState: true
    }
};

export default timelineHappyPath;
